module.exports = __webpack_public_path__ + "static/media/49.cbe965ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/49.jpg
// module id = 418
// module chunks = 0